export default "__VITE_ASSET__2c4dd790__"